import React, { createContext, useCallback, useContext, useState, useSyncExternalStore } from 'react';
import type { ReactElement, ReactNode } from 'react';
import type { PluginNamespace } from '../types/envelope.js';
import type { HtsUri } from '../types/uri.js';
import type { MeshAdapter } from './adapter.js';

export const MeshContext = createContext<MeshAdapter | null>(null);

export interface MeshProviderProps {
  adapter: MeshAdapter;
  children: ReactNode;
}

export function MeshProvider(props: MeshProviderProps): ReactElement {
  return (
    <MeshContext.Provider value={props.adapter}>
      {props.children}
    </MeshContext.Provider>
  );
}

export function useMeshState(uri: HtsUri, pluginId: PluginNamespace, resourceId: string): unknown {
  const adapter = useContext(MeshContext);
  if (adapter === null) throw new Error('useMeshState requires a MeshProvider');

  useState(() => {
    adapter.track(uri, pluginId, resourceId);
    return true;
  });

  const subscribe = useCallback((callback: () => void) => adapter.subscribe(uri, callback), [adapter, uri]);
  const getSnapshot = useCallback(() => adapter.getSnapshot(uri), [adapter, uri]);

  return useSyncExternalStore(subscribe, getSnapshot, getMeshServerSnapshot);
}

export function getMeshServerSnapshot(): unknown {
  return undefined;
}
